import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import image from "../../assets/door-access/control-hubs/enterprise-access-hub.png";
import type { Product } from "../../types";
import { doorAccessControlHubs } from "../product-list-groups/doorAccessControlHubs";
import { accessPowerMethod } from "../properties/accessPowerMethod";
import { inputTerminals } from "../properties/inputTerminals";
import { outputRelays } from "../properties/outputRelays";
import { poePorts } from "../properties/poePorts";
import { powerRedundancy } from "../properties/powerRedundancy";

export const enterpriseAccessHub: Product = {
  id: "enterpriseAccessHub",
  productTitle: "Enterprise Access Hub",
  description: "enterpriseAccessHub.description",
  productListGroup: doorAccessControlHubs,
  techspecsPath: [SiteId.TechSpecs, "/unifi/door-access/eah-8"],
  storePathParts: { category: "all-door-access", productSlug: "eah-8" },
  descriptionMaxWidth: 247,
  image: { src: image, width: 200, height: 160 },
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "string",
        value: '379 x 355 x 105 mm\n(15 x 14 x 4.1")',
      },
    },
    {
      propertyId: outputRelays.id,
      value: {
        type: "translation",
        value: "enterpriseAccessHub.outputRelays",
      },
    },
    {
      propertyId: inputTerminals.id,
      value: {
        type: "translation",
        value: "enterpriseAccessHub.inputTerminals",
      },
    },
    {
      propertyId: poePorts.id,
      value: {
        type: "translation",
        value: "enterpriseAccessHub.poePorts",
      },
    },
    {
      propertyId: accessPowerMethod.id,
      value: {
        type: "translation",
        value: "commons.powerMethod.acPower",
      },
    },
    {
      propertyId: powerRedundancy.id,
      value: {
        type: "translation",
        value: "enterpriseAccessHub.powerRedundancy",
      },
    },
  ],
};
